import { render, staticRenderFns } from "./input-phone.vue?vue&type=template&id=0f89903f&scoped=true&"
import script from "./input-phone.vue?vue&type=script&lang=js&"
export * from "./input-phone.vue?vue&type=script&lang=js&"
import style0 from "./input-phone.vue?vue&type=style&index=0&id=0f89903f&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f89903f",
  null
  
)

export default component.exports